<template>
  <div class="container">
    <div class="header">
      <div class="logo">
        <img src="../assets/images/logo-small.png" alt="logo" />
        <span>Your TPR Coin Allocation Platform</span> 
      </div>   
      <div class="login" @click="logout">logout</div>
    </div>
    <div style="display:flex; justifyContent:center" v-if="loading">
      <Spin size="large"></Spin>
    </div>
    <main class="main">
      <router-view />
    </main>
    <div class="privacy-text"><a href="https://thepeoplesreserve.com/privacy-policy/" target="_blank">Privacy Policy</a> </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    logout() {
      this.$store.dispatch('logout')
      .then(() => {
        this.$router.push('/login')
      })
    },
  },
  computed: {
    loading() {
      return this.$store.getters.getGlobalLoading
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  display: flex;
  flex-direction: column;
  background-image: url("../assets/images/bg.png");
  background-repeat: no-repeat;
  background-size: cover;
  max-width: 100%;
  min-height: 100vh;
  padding: 0 20px 20px;
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #edf1f9;
    padding-right: 10px;

    .logo {
      display: flex;
      align-items: center;
      
    }
    .login {
      font-family: Roboto;
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      line-height: 24px;
      display: flex;
      align-items: center;
      text-align: right;
      letter-spacing: 0.01em;
      text-transform: uppercase;
      color: #edf1f9;
      cursor: pointer;
    }
  }
  .main {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-grow: 1;
    .title {
      width: 50%;
      &__text {
        font-family: Roboto;
        font-style: normal;
        font-weight: 900;
        font-size: 48px;
        line-height: 60px;
        color: #ffffff;
        span {
          color: #fadb08;
        }
      }
      &__img {
        margin-top: -70px;
      }
    }
  }
}
@media screen and (max-width: 600px) {
  .logo {
    img {
      margin-left: -25px;
    }
    span {
      font-size: 12px;
    }
  }
}
</style>